import css from '@styled-system/css';
import styled from 'styled-components';
import { BLOCKS } from '@contentful/rich-text-types';

import TextContainer from 'humanity/components/textContainer';
import Box from 'humanity/primitives/box';
import Container from 'humanity/primitives/container';
import Grid from 'humanity/primitives/grid';
import Heading from 'humanity/primitives/heading';
import Section from 'humanity/primitives/section';
import { faqsDefaultProps, faqsProps } from 'humanity/sections/faqs/faqs.types';
import Faq from 'humanity/components/faq';
import SimpleRichText from 'humanity/components/simpleRichText';
import Text from 'humanity/primitives/text';
import { getPaddingValues } from 'utils/getPaddingValues';

const FaqsWrapper = styled(Box)(
  css({
    gridColumnStart: '1',
    gridColumnEnd: ['span 12', null, null, 'span 8'],
  })
);

const renderOpts = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text variant="lead">{children}</Text>,
  },
};

const Faqs = ({
  backgroundColor,
  topPadding,
  bottomPadding,
  heading,
  faqs,
  additionalCopy,
  ...props
}) => (
  <Section
    pt={getPaddingValues(topPadding)}
    pb={getPaddingValues(bottomPadding)}
    {...props}
  >
    <Container>
      <TextContainer textAlign="left">
        <Heading
          variant={['h3', null, null, 'h2']}
          dangerouslySetInnerHTML={{ __html: heading?.trim() }}
        />
      </TextContainer>
      <Grid>
        <FaqsWrapper>
          {faqs.map((faq, index) => (
            <Box mt={[6, null, 7]} key={faq.sys?.id}>
              <Faq index={index} title={faq.title} content={faq.content} />
            </Box>
          ))}
        </FaqsWrapper>
      </Grid>
      <Box mt={[6, null, 7]}>
        <SimpleRichText content={additionalCopy?.json} renderOptions={renderOpts} />
      </Box>
    </Container>
  </Section>
);

Faqs.propTypes = {
  ...faqsProps,
};

Faqs.defaultProps = {
  ...faqsDefaultProps,
};

export default Faqs;
